import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Button} from "../buttons/button";

export class ToggleButtonProps extends BaseProps {
  active: Boolean;
  label: String;
  className: String;
  onClick: Function;
}

export const ToggleButton = (props: ToggleButtonProps) => {
  const className = [props.className, 'toggle-container', (props.active ? 'toggle-container-active' : '')].join(' ');
  const onClick = () => props.onClick && props.onClick();

  const containerProps = {
    className,
    onClick
  }

  return (
    <Button {...containerProps}>
      {
        props.label
      }
    </Button>
  )
}
